import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReactComponent as CalendarSVG } from "go-core/images/svg/calendar.svg";
import { ReactComponent as InvoiceTypeSVG } from "go-core/images/svg/file.svg";
import { KSeFInvoiceApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	ksefData: KSeFInvoiceApi;
}

export const KSeFInfoCard = ({ ksefData }: Props) => {
	const { t } = useTranslation();
	const { created_at, error, status, invoice_number } = ksefData;

	return (
		<Col xs={12}>
			<Card>
				<Card.Body>
					<Card.Title as="h5">{t("modules.invoice.header.ksef_info.title")}</Card.Title>
					<Row>
						<Col md={3} className="card-body-item">
							<CalendarSVG />
							<div className="item-info">
								<span className="label">{t("lib:common.word.created_at")}</span>
								<span>{FormatDate(created_at)}</span>
							</div>
						</Col>
						<Col md={3} className="card-body-item">
							<InvoiceTypeSVG />
							<div className="item-info">
								<span className="label">{t("lib:common.word.status")}</span>
								<span>{t(`enums.common.status.${status}`, { ns: ["lib", "translation"] })}</span>
							</div>
						</Col>
						<Col md={3} className="card-body-item">
							<InvoiceTypeSVG />
							<div className="item-info">
								<span className="label">{t("modules.invoice.field.ksef_number.title")}</span>
								<span>{invoice_number}</span>
							</div>
						</Col>
						{error && (
							<Col md={3} className="card-body-item">
								<InvoiceTypeSVG />
								<div className="item-info">
									<span className="label">{t("modules.invoice.field.error.title")}</span>
									<span>{error}</span>
								</div>
							</Col>
						)}
					</Row>
				</Card.Body>
			</Card>
		</Col>
	);
};

// t("enums.common.status.PENDING")
